import React from 'react';
import { FormatOptionLabelMeta } from '@atlaskit/select';
import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import { SPACE_MINIMUM, colors, textOverflowHidden } from '@/styles';

function OptionLabel<T>({ description, label }: Pick<FieldOption<T>, 'description' | 'label'>) {
  return (
    <div>
      <p>{label}</p>
      {description ? (
        <div
          css={[
            css`
              color: ${token('color.text.subtlest', colors.N300)};
              margin: ${SPACE_MINIMUM}px 0;
              font-size: 0.8em;
            `,
            textOverflowHidden,
          ]}
        >
          {description}
        </div>
      ) : null}
    </div>
  );
}

export function formatOptionLabel<T>(
  option: FieldOption<T>,
  { context }: FormatOptionLabelMeta<FieldOption<T>>
) {
  if (context === 'menu') {
    return <OptionLabel<T> description={option.description} label={option.label} />;
  }
  return option.label;
}

export default OptionLabel;
